<h2>{{ modalTitle }}</h2>
<form [formGroup]="serviceForm" (ngSubmit)="submitForm()">


    <div class="mat-form-field">
        <mat-form-field>
            <mat-label>Select Service:</mat-label>
            <mat-select formControlName="selectedService">
                <mat-option *ngFor="let service of serviceCategories" [value]="service.uuid">
                    {{ service.category }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</form>

<div class="buttons">
    <button mat-raised-button color="primary" [disabled]="serviceForm.invalid" (click)="submitForm()">Remove Service</button>
    <button mat-raised-button color="primary" (click)="closeModal()">Close</button>
</div>